import {
    ArcCircleIntersectionSolver,
    type ArcCircleIntersection2D,
    type CircularArcIntersectionDefinition2D,
} from './ArcCircleIntersectionSolver';

/**
 * 两条圆弧的单个真实交点。
 */
export interface ArcArcIntersection2D extends ArcCircleIntersection2D {
    /** 交点在第一条圆弧上的局部参数，范围 `[0, 1]`。 */
    firstArcParameter: number;
    /** 交点在第二条圆弧上的局部参数，范围 `[0, 1]`。 */
    secondArcParameter: number;
}

/**
 * 两条圆弧的真实交点求解器。
 *
 * 该类继续继承圆弧与圆求解器：父类先过滤第一条圆弧，
 * 本类再过滤第二条圆弧，从而避免复制圆—圆解析算法。
 */
export class ArcArcIntersectionSolver extends ArcCircleIntersectionSolver {
    /**
     * 求解两条圆弧的全部真实交点。
     *
     * @param firstArc 第一条圆弧定义。
     * @param secondArc 第二条圆弧定义。
     * @returns 同时位于两条圆弧有效域内的真实交点。
     */
    public solveArcs(
        firstArc: CircularArcIntersectionDefinition2D,
        secondArc: CircularArcIntersectionDefinition2D,
    ): ArcArcIntersection2D[] {
        return super.solveArcCircle(firstArc, secondArc).flatMap((intersection) => {
            // 第二个支撑圆角参数只在本层过滤，保持每一层只有一个明确职责。
            const secondArcParameter = this.projectAngleToDomainParameter(
                intersection.secondCircleAngle,
                secondArc,
            );
            return secondArcParameter === null
                ? []
                : [{
                    ...intersection,
                    firstArcParameter: intersection.arcParameter,
                    secondArcParameter,
                }];
        });
    }
}
